import Advantages from "./advantages";
import BlogHero from "./blogHero";
import FollowUs from "./followUs";
import Tips from "./tips";
import WhatMakeUs from "./WhatMakeUs";
import WhyRead from "./whyRead";

const Blog = () => {
  return (
    <main>
      <BlogHero />
      <WhyRead />
      <Tips />
      <WhatMakeUs />
      <Advantages />
      <FollowUs />
    </main>
  );
};

export default Blog;
